module.exports = __webpack_public_path__ + "assets/success-checkmark.4dd1f5f1.svg";